import template from './changes-register-data.html';

class ChangesRegisterDataComponent {}

export const ChangesRegisterData = {
  bindings: {
    changes: '<'
  },
  controller: ChangesRegisterDataComponent,
  template
};
